import { render } from "./buyer.vue?vue&type=template&id=033f23b7&scoped=true"
import script from "./buyer.vue?vue&type=script&lang=js"
export * from "./buyer.vue?vue&type=script&lang=js"

import "./buyer.vue?vue&type=style&index=0&id=033f23b7&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033f23b7"]])

export default __exports__